import Checkbox from "@/Components/Checkbox/Checkbox";
import DraggableRow from "@/Components/DraggableRow/DraggableRow";
import { reorder } from "@/shared/utils/helpers";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const Sections = () => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });
  const { control } = useFormContext();

  return (
    <Controller
      name="sectionList"
      control={control}
      render={({ value: sectionList, onChange }) => (
        <DraggableRow
          label={t("sections")}
          droppableId="sectionDroppabelId"
          onDrageEnd={({ destination, source }) => {
            if (!destination) {
              return;
            }
            onChange(reorder(sectionList, source.index, destination.index));
          }}
          list={sectionList.map((item) => ({
            key: item.name,
            component: (
              <>
                <div className="mr-[2rem]">
                  <Checkbox
                    checked={item.isActive}
                    active={item.isActive}
                    name={item.name}
                    onChange={(e) => {
                      const newData = sectionList.map((item) => {
                        if (item.name === e.target.name) {
                          return {
                            ...item,
                            isActive: e.target.checked,
                          };
                        } else {
                          return { ...item };
                        }
                      });

                      onChange(newData);
                    }}
                  />
                </div>
                <div>{t(item.label)}</div>
              </>
            ),
          }))}
        />
      )}
    />
  );
};

export default Sections;
